import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { Filter } from '../../ts/helpers/Filter';
import { Order } from '../../ts/helpers/Order';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import {
  GetDestinationProjectsRequest,
  IGetDestinationProjectsResult,
} from '../../ts/ServerApi/requests/GetDestinationProjectsRequest';
import { IDestinationProject } from '../../ts/ServerApi/types/IDestinationProject';
import { NamedItemKeys } from '../../ts/ServerApi/types/resourceParts';

export type DestinationProjectContentType = 'project' | 'workbook' | 'datasource' | 'flow' | 'dataRole' | 'lens' | 'metric' | 'publishedConnection';

class DestinationProjectsResource {

  private fetcher = new WebClientListResourceFetcher(GetDestinationProjectsRequest, (result: IGetDestinationProjectsResult) => result.projects);

  public getQueryForSpecificSourceContentAndMatchText(
    contentType: DestinationProjectContentType,
    sourceIds: string[],
    matchText: string
  ): ResourceQuery<IDestinationProject> {
    return new ResourceQuery(this.fetcher)
      .withExtraParams({ 'contentType': contentType, 'sourceIds': sourceIds })
      .withFiltersAndOrder([Filter.search(matchText)], [Order.asc(NamedItemKeys.name)]);
  }
}

export const DestinationProjects = new DestinationProjectsResource();
